import { z } from "zod";

export enum RequestStateTypeEnum {
    ROZPRACOVANA = 1,
    ULOZENA = 2,
    ODOSLANA_NA_SPRACOVANIE = 3,
    RIESI_SA = 4,
    CAKA_SA_NA_NIEKOHO = 5,
    NEOPODSTATNENA = 6,
    VYBAVENA = 7,
    VYBAVENA_A_POSLANA_NA_DALSIU_CINNOST = 8,
    ZRUSENA_A_NAHRADENA_INOU_CINNOSTOU = 9,
    ODOSLANA_NA_PODPIS = 10,
    ZIADOST_PODPISANA_RUCNE = 11,
    LINK_ODOSLANY_EMAILOM = 12,
    LINK_ODOSLANY_SMS = 13,
    POTVRDENIE_ZRUSENE = 14,
    LINK_POTVRDENY_KLIENTOM = 15
}

export const RequestStateTypeEnumSchema = z.nativeEnum(RequestStateTypeEnum);
